import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import CalendarBodyDayCalendar from "../body/day/calendar-body-day-calendar";
import { useCalendarContext } from "../calendar-context";

const DatePickerDialog = () => {
    const {datePickerDialogOpen, setDatePickerDialogOpen} = useCalendarContext()
    return (
        <Dialog open={datePickerDialogOpen} onOpenChange={setDatePickerDialogOpen}>
            <DialogContent className="w-[400px]">
                <DialogHeader>
                <DialogTitle>Select date</DialogTitle>
                    <DialogDescription>
                        This will take you to the daily view of the selected date.
                    </DialogDescription>
                    <div className="w-full flex justify-center">
                        <CalendarBodyDayCalendar />
                    </div>
                </DialogHeader>
            </DialogContent>
        </Dialog>
    )
}

export default DatePickerDialog